/* eslint-disable no-case-declarations */
import { ROUTER_CHANGE } from '../actions/routerActions';

/**
 * Reducer function means a switch case to filter action data on the platform for general state
 * @param {*} state Real time updated through all components state (general state flux)
 * @param {*} action Action is an object with structyure { type: STRING, payload: FUNCTION }
 */
function routerReducer(state = { router_change: false }, action) {
  switch (action.type) {
    case ROUTER_CHANGE:
      return {
        ...state,
        router_change: !state.router_change
      };
    default:
      return state;
  }
}

export default routerReducer;
